export default __webpack_public_path__ + "static/media/46.9b97ae37.jpg";